import { Chip } from "@mui/material";
import React from "react";

export const StatusBadge = (props: { active: boolean }) => {
    return (
        <Chip
            label={props.active ? "Active" : "Inactive"}
            size="small"
            sx={{
                backgroundColor: props.active ? "#4caf50" : "#9e9e9e",
                color: "white",
                fontWeight: 500,
                '& .MuiChip-label': {
                    color: "white"
                }
            }}
        />
    );
}

